import moment from "moment"

export default {
	load() {
		return {
			fields: {
				templateId: {
					value: "request_CT_IMEA"
				},

				idHospPrip: {
					label: "Číslo hospitalizačného prípadu"
				},

				name: {},
				nameForm: {
					label: "Meno a priezvisko"
				},
				identifier: {},
				identifierForm: {
					label: "Rodné číslo"
				},
				insurerCode: {},
				insurerForm: {
					label: "Zdravotná poisťovňa"
				},

				addressForm: {
					label: "Bydlisko"
				},
				address: {},

				employment: {
					label: "Zamestnanie"
				},

				doctorname: {},
				orgunitname: {},
				orgunitaddress: {},

				doctorcode: {},
				orgunitcode: {},
				orgunitcodeForm: {
					label: "Kód odosielajúceho lekára (ambulancie)"
				},

				odporPersonnelExpertiseId: {
					label: "Odporúčajúci lekár"
				},
				odporDoctorId: {},
				odporDoctorOUPZS: {
					label: "Odporúčajúci OUPZS"
				},
				odporACode: {},
				odporPCode: {},
				//
				clinicalDiagnosis: {
					label: "Klinická diagnóza",
					rules: "required"
				},
				diagnosisNameExt: {},
				diagnosisCodeExt: {},
				sendingDoctor: {
					label: "Odosielajúci ústav, oddelenie, meno lekára"
				},
				expertise_id: {},
				personnel_id: {},
				provider_id: {},
				orgunitcontact: {},
				orgunitcontactForm: {
					label: "tel. číslo"
				},
				doctorCode: {},
				doctorName: {},
				phone: {},

				examinationDatetime: {
					label: "Termín CT vyšetrenia",
					value: moment()
				},
				examinationDate: {
					value: moment().format("DD.MM.YYYY")
				},
				examinationTime: {
					value: moment().format("HH:mm")
				},

				anamnesis: {
					label: "Anamnéza"
				},
				alergyAnamnesis: {
					label: "Alergická anamnéza"
				},
				epikriza: {
					label: "Terajšie ochorenie - epikríza"
				},
				rtgUsg: {
					label: "Závery predchádzajúcich rtg a USG vyšetrení"
				},
				ctOrgunitName: {
					label: "Pracovisko"
				},
				ctExaminationDate: {
					label: "Dátum vyšetrenia",
					value: moment(),
					type: "date"
				},
				ctExaminationEnd: {
					label: "Záver"
				},
				questionCTExamination: {
					label: "Ktorý orgán má byť CT vyšetrený"
				},
				questionCTExaminationAnswer: {
					label: "Otázka, ktorá má byť CT vyšetrením zodpovedaná"
				},
				date: {
					label: "Dátum",
					value: moment(),
					type: "date"
				}
			}
		}
	}
}
